export const domReady = (callback) => {
  // Normalize DOMContentLoaded vs already-ready states for small bundles.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
};
